<!-- 在线课程 -->
<template>
  <div class="online-courses">
    <div class="online-courses-title">
      <div class="name">在线课程</div>
    </div>
    <div class="online-courses-box">
      <div class="online-courses-number">
        <div class="tips"></div>
        <div class="title">总课程（个）</div>
        <div class="number">{{zxkcNum}}</div>
      </div>
      <div class="online-courses-button">
        <div class="synch" :class="activeName == 'synch' ? 'is-select' : ''" @click="selectCourseBtn('synch')">同步课程</div>
        <div class="delivery" :class="activeName == 'delivery' ? 'is-select' : ''" @click="selectCourseBtn('delivery')">专业课程</div>
      </div>
    </div>
    <div class="online-courses-charts">
        <div class="chart" id="onlineCoursesId" v-show="!isShow"></div>
        <div class="chart-error" v-show="isShow">
            <div class="detail">
                <span class="detail">暂无数据</span>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import {getPlatformCourseStatAPI,getPlatformSpecialCourseStatAPI} from "@/service/api.js"
export default {
  name: 'online-courses',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    //区域平台类型
    regionType:{
      type:String,
      default:""
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    //学校id
    schoolId:{
      type:String,
      default:""
    },
    //课程数量
    zxkcNum:{
      type:Number,
      default:0
    }
  },
  watch:{
    startTime(){
      if(this.activeName=='synch'){
        this.getPlatformCourseStat();
      }else{
        this.getPlatformSpecialCourseStat();
      }
    },
    endTime(){
      if(this.activeName=='synch'){
        this.getPlatformCourseStat();
      }else{
        this.getPlatformSpecialCourseStat();
      }
    },
    schoolId(){
      if(this.activeName=='synch'){
        this.getPlatformCourseStat();
      }else{
        this.getPlatformSpecialCourseStat();
      }
    },
    address(){
      if(this.activeName=='synch'){
        this.getPlatformCourseStat();
      }else{
        this.getPlatformSpecialCourseStat();
      }
    }
  },
  data() {
      return {
        courseNumber:0,
        specialCourseNumber:0,
        activeName:'synch',
        synchList:[],
        isShow:false,
        deliveryList:[]
      }
  },
  methods: {
    /**
     * @name 切换
     */
    selectCourseBtn(type){
      
      if(this.activeName == type){
        return;
      }
      this.isShow = false
      this.activeName = type;
      if(type=='synch'){
        this.getPlatformCourseStat();
      }else{
        this.getPlatformSpecialCourseStat();
      }
      // this.initEchart();
    },

    /**
     * @name 初始化图表
     */
    initEchart(){
      let _this = this;
      let namelist = []
      if(this.activeName == 'synch'){
        namelist = this.synchList.map((item)=>{
          return {
            ...item,
            name:`${item.title}   ${item.value}`
          }
        })
      }else{
        namelist = this.deliveryList.map((item)=>{
          return {
            ...item,
            name:`${item.title}   ${item.value}`
          }
        })
      }
      
      let dataSource = _this.$echarts.init(
          document.getElementById('onlineCoursesId')
      );
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: (data) => {
            return data.data.title + "：" + data.value;
          },
        },
        legend: {
          orient: "vertical",
          left: "60%",
          top: "middle",
          icon: "circle",
          textStyle: {
            color: "#FFF",
            rich: {
              a: {
                align: "left",
                width: 100,
              },
              b: {
                align: "left",
                fontWeight: "bold",
                width: 100,
              },
            },
          },
          data:namelist
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              formatter: (data) => {
                return (
                  "{a|" +
                  data.data.value +
                  "}" +
                  "\r\n" +
                  "{b|" +
                  data.data.title +
                  "}"
                );
              },
              rich: {
                a: {
                  fontSize: 16,
                  lineHeight: 18,
                  color: "#fff",
                  fontWeight: "bold",
                  align: "center",
                },
                b: {
                  fontSize: 12,
                  lineHeight: 14,
                  color: "#fff",
                  align: "center",
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data:namelist
          }
        ]
      };
      dataSource.setOption(option);
      window.addEventListener("resize", function () {
          dataSource.resize();
      });
    },

    /**
     * @name 获取平台在线课程统计
     */
    getPlatformCourseStat(){
      let params = {
        regionId:this.regionId,
        schoolId:this.schoolId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformCourseStatAPI(params).then((res)=>{
        this.synchList = []
        this.synchList.push({
          title:'小学',
          value:res.primarySyncCsNum || 0
        })
        this.synchList.push({
          title:'初中',
          value:res.juniorSyncCsNum || 0
        })
        this.synchList.push({
          title:'高中',
          value:res.seniorSyncCsNum || 0
        })
        if((res.syncCsNum - res.primarySyncCsNum- res.juniorSyncCsNum-res.seniorSyncCsNum) > 0){
          this.synchList.push({
            title:'其他',
            value:(res.syncCsNum - res.primarySyncCsNum- res.juniorSyncCsNum-res.seniorSyncCsNum) || 0
          })
        }
        this.courseNumber = res.syncCsNum || 0
        this.specialCourseNumber = res.ztCsNum || 0
        console.log(this.synchList)
        this.initEchart();
      }).catch((err)=>{})
    },
    /**
     * @name 获取平台专题在线课程统计
     */
    getPlatformSpecialCourseStat(){
      let params = {
        regionId:this.regionId,
        schoolId:this.schoolId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        page:1,
        limit:10,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformSpecialCourseStatAPI(params).then((res)=>{
        this.deliveryList = res.rows.map((item)=>{
          return {
            title:item.specialTitle,
            value:item.ztCsNum
          }
        })
        if(this.deliveryList.length == 0){
          this.isShow = true;
        }
        this.initEchart();
      }).catch((err)=>{})
    }
  },
  mounted(){
    if(this.activeName == 'synch'){
      // 获取平台在线课程统计
      this.getPlatformCourseStat();
    }else{
      // 获取平台专题在线课程统计
      this.getPlatformSpecialCourseStat();
    }
  },
}
</script>

<style lang="scss" scoped>
.online-courses{
  width: 100%;
  margin-top: 20px;
  .online-courses-title{
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    height: 40px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .online-courses-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .online-courses-number{
    display: flex;
    align-items: center;
    margin-top:24px;
    margin-left: 18px;
    .tips{
      width: 10px;
      height: 10px;
      background: #FFDF25;
      border-radius: 50%;
      margin-right: 4px;
    }
    .title{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #C4D6F2;
      margin-right: 15px;
    }
    .number{
      font-size: 32px;
      font-family: MaravaleExpanded;
      font-weight: normal;
      color: #6FEFFF;
      @font-face {
        font-family: MaravaleExpanded;
        src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
      }
    }
  }
  .online-courses-button{
    display: flex;
    align-items: center;
    margin-top: 24px;
    .synch,
    .delivery{
      padding: 8px 11px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      border-radius: 4px;
      color: #5B90E6;
      background: rgba(31,51,141,0.57);
      cursor: pointer;
    }
    .synch{
      margin-right: 13px;
    }
    .is-select{
      color: #FFFFFF;
      background: linear-gradient(0deg, #177BC1 0%, #20B8CE 100%);
    }
  }
  .online-courses-charts{
    width: 100%;
    height: 200px;
    .chart{
      width: 100%;
      height: 100%;
    }
  }
}
.chart-error{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .detail{
    font-size: 16px;
    color: #fff;
  }
}
</style>
<style lang="scss">
</style>